<div class="file-container">
  <!-- Close Button -->
  <button
    class="p-button-rounded p-button-danger"
    type="button"
    icon="pi pi-times"
    pButton
    pRipple
    (click)="removeFile.emit()"
    *ngIf="showRemoveButton"
  ></button>

  <!-- Image Preview -->
  <div class="preview">
    <ng-container *ngIf="isDocumentFile(url); else imagePreview">
      <!-- Show file icon for doc/pdf -->
      <img src="assets/images/icons/file-icon.png" alt="Document icon" />
    </ng-container>

    <ng-template #imagePreview>
      <ng-container *ngIf="url !== undefined && url !== null; else fileIconPreview">
        <!-- Show image preview -->
        <img [src]="url" alt="Preview image" />
      </ng-container>

      <ng-template #fileIconPreview>
        <img src="assets/images/icons/file-icon.png" alt="Document icon" />
      </ng-template>
    </ng-template>
  </div>

  <div
    class="details-section"
    [class.compact]="isCompact || mediaObserver.isActive('xs')"
    *ngIf="name != null && size != null"
  >
    <!-- File Name -->
    <div class="file-name">{{ name }}</div>

    <!-- File Size -->
    <div>{{ helperService.formatSize(size) }}</div>
  </div>
</div>
